export enum DistributionUsed {
    Normal = 0,
    LogNormal = 1
}

export enum DistributionUsedNamesEnum {
    'Normal' = DistributionUsed.Normal,
    'Log Normal' = DistributionUsed.LogNormal
}
